// $(window).on('load', function() {
//     if ($(".ac-swatch[value='1 Box']").attr("checked") == "checked") {
//         updateSellingPlan(1);
//     } else if($(".ac-swatch[value='3 Boxes']").attr("checked") == "checked") {
//         updateSellingPlan(3);
//     } else if($(".ac-swatch[value='6 Boxes']").attr("checked") == "checked") {
//         updateSellingPlan(6);
//     }
// });

$(document).ready(function() {
    $("#appstle_subscription_widget0, .appstle_subscription_radio_wrapper input[type='radio']").css('transition', 'all 0.1s ease');
    
    // setTimeout(function() {
    //     if (!!document.querySelector('label.ac-3-Boxes') && (window.innerWidth > 767)) {
    //         document.querySelector('label.ac-3-Boxes').click();
    //     }
    // }, 2000);

    $("product-info[data-url='/products/zima-dental-gift-card'] .product-form__input .ac-swatch").on("change", function() {
        var clicked_id = $(this).attr("id");
        console.log(clicked_id);
    });

    $(".menu-drawer__menu li.is-dropdown").click(function() {
        console.log("testletter");
        $(".menu-drawer__menu li .icon-caret").toggleClass("menu_item_active");
    });

    $("header-drawer .header__icon").click(function() {
        $(".announcement-bar").slideToggle();
    });

    $('.ac-tablet .ac-1-Box').on('click', function() {
        updateSellingPlan(1);
    });
    $('.ac-tablet .ac-3-Boxes').on('click', function() {
        updateSellingPlan(3);
    });
    $('.ac-tablet .ac-6-Boxes').on('click', function() {
        updateSellingPlan(6);
    });

    $('.ac-wipes .ac-1-Box').on('click', function() {
        updateSellingPlan1(1);
    });
    $('.ac-wipes .ac-2-Boxes').on('click', function() {
        updateSellingPlan1(2);
    });
    $('.ac-wipes .ac-3-Boxes').on('click', function() {
        updateSellingPlan1(3);
    });
  

    $(".product__info-wrapper .pro-des-tab").last().css("border-bottom", "1px solid #e1e1e1");
    $("#pdp-dpk-acco1 .accordion_container .accordions").last().css("border-bottom", "1px solid #e1e1e1");
    $("#mobile-tablet-question .accordion_container .accordions").last().css("border-bottom", "1px solid #e1e1e1");

    // Add transition effect to the dropdown
    $("#appstle_selling_plan0").css('transition', 'opacity 0.2s ease');
});

function updateSellingPlan(box) {
    // Hide the dropdown
    $("#appstle_selling_plan0").css('opacity', '0');

    setTimeout(function() {
        var selectedIndex;
        var selectedPlanValue;

        // Use requestAnimationFrame
        requestAnimationFrame(function() {
            if (box === 1) {
                selectedIndex = 0;
            } else if (box === 3) {
                selectedIndex = 1;
            } else if (box === 6) {
                selectedIndex = 2;
            }

            // Update dropdown and radio button value
            $("#appstle_selling_plan0").prop('selectedIndex', selectedIndex);
            selectedPlanValue = $("#appstle_selling_plan0 option:selected").val();
            $(".appstle_subscription_radio_wrapper input[type='radio']:checked").val(selectedPlanValue);

            // Add or remove class based on box count
            var amountClass = box === 6 ? 'addClass' : 'removeClass';
            $("#appstle_subscription_widget0 .appstle_subscription_amount")[amountClass]('is6box');

            // Set data attribute
            $("#appstle_subscription_widget0").attr("data-selected-selling-plan", selectedPlanValue);

            // Show the dropdown
            $("#appstle_selling_plan0").css('opacity', '1');
        });
    }, 0);
}



function updateSellingPlan1(box) {
    // Hide the dropdown
    $("#appstle_selling_plan0").css('opacity', '0');

    setTimeout(function() {
        var selectedIndex;
        var selectedPlanValue;

        // Use requestAnimationFrame
        requestAnimationFrame(function() {
            if (box === 1) {
                selectedIndex = 0;
            } else if (box === 2) {
                selectedIndex = 2;
            } else if (box === 3) {
                selectedIndex = 2;
            }

            // Update dropdown and radio button value
            $("#appstle_selling_plan0").prop('selectedIndex', selectedIndex);
            selectedPlanValue = $("#appstle_selling_plan0 option:selected").val();
            $(".appstle_subscription_radio_wrapper input[type='radio']:checked").val(selectedPlanValue);

            // Add or remove class based on box count
            var amountClass = box === 6 ? 'addClass' : 'removeClass';
            $("#appstle_subscription_widget0 .appstle_subscription_amount")[amountClass]('is6box');

            // Set data attribute
            $("#appstle_subscription_widget0").attr("data-selected-selling-plan", selectedPlanValue);

            // Show the dropdown
            $("#appstle_selling_plan0").css('opacity', '1');
        });
    }, 0);
}